const newsList = document.getElementById('newsList');
const loadMoreBtn = document.getElementById('loadMoreBtn');
const itemsPerPage = 10;
let visibleItems = itemsPerPage;

if (newsList) {
	function loadMoreNewsItems() {
		const hiddenItems = newsList.querySelectorAll('.newsItem');

		if (itemsPerPage > hiddenItems.length) {
			loadMoreBtn.style.display = 'none';
			return;
		}

		for (let i = itemsPerPage; i < hiddenItems.length; i++) {
			hiddenItems[i].style.display = 'none';
		}
		loadMoreBtn.addEventListener('click', function () {
			for (let i = visibleItems; i < visibleItems + itemsPerPage; i++) {
				if (hiddenItems[i]) {
					hiddenItems[i].style.display = 'flex';
				} else {
					loadMoreBtn.style.display = 'none';
					break;
				}
			}
			visibleItems += itemsPerPage;
		});
	}

	loadMoreNewsItems()
}
